import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Create } from '@mui/icons-material';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { styled as muiStyled } from '@mui/styles';
import Grid from '@mui/material/Grid';
import { createSelector } from 'reselect';

export const SurveyListGrid = muiStyled(Grid)({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
});

export const WideButton = muiStyled(Button)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  textAlign: 'left',
  flex: 1,
});

const mapState = createSelector(
  ({ selectedSurveyLayers }) => selectedSurveyLayers,
  (selectedSurveyLayers) => ({ selectedSurveyLayers })
);

export const SurveyListItem = ({ survey, showGrid, editSurvey }) => {
  const dispatch = useDispatch();
  const { selectedSurveyLayers } = useSelector(mapState);
  const selectedSurvey = selectedSurveyLayers[survey.id];

  const onChange = useCallback(() => {
    dispatch({
      type: selectedSurvey ? 'HIDE_SURVEY_LAYER' : 'SHOW_SURVEY_LAYER',
      payload: {
        survey,
      },
    });

    dispatch({
      type: 'TRACK',
      payload: {
        name: 'Survey Layer Selected',
        survey,
      },
    });
  }, [dispatch, survey, selectedSurvey]);

  return (
    <SurveyListGrid item xs={12}>
      <Checkbox checked={Boolean(selectedSurvey)} onChange={onChange} />
      <WideButton onClick={(e) => showGrid(e, survey)}>
        {survey.name || 'Unnamed Survey'}
        <Create onClick={(e) => editSurvey(e, survey)} />
      </WideButton>
    </SurveyListGrid>
  );
};
